import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { InspectionsPageContext } from "../InspectionsPage";
import { GaugeConfig, PeakSignalModel, PeakSignalUpdateModel } from "../../../data/entities";
import { SpinnerDefault, TitlelessCard } from "../../../components";
import { InspectionService, UserService } from "../../../services";
import { Roles } from "../../../models";
import { PeakSignalTable } from "../../cteye/components";

export function InspectionsDataPeakSignals() {
  const context: InspectionsPageContext = useOutletContext();
  context.setTitle("Peak Signals");

  const { id } = useParams();
  const inspectionId = Number(id);
  const [peakSignals, setPeakSignals] = useState<PeakSignalModel[]>([]);
  const [gaugeConfig, setGaugeConfig] = useState<GaugeConfig | null>(null);
  const [loading, setLoading] = useState(true);

  const service = new InspectionService();

  const loadPeakSignals = async () => {
    const response = await service.getPeakSignals(inspectionId);
    setPeakSignals(response?.peakSignals ?? []);
    setGaugeConfig(response?.gaugeSettings ?? null);
  };

  useEffect(() => {
    setLoading(true);
    loadPeakSignals()
      .catch((error) => console.error("Error loading peak signals:", error))
      .finally(() => setLoading(false));
  }, [inspectionId]);

  const canEditPeaks = UserService.isInAnyRole([Roles.admin, Roles.dataAnalyst]);
  const handlePeakUpdate = async (signal: PeakSignalModel, changes: PeakSignalUpdateModel) => {
    await service.updatePeakSignal(signal.id, changes);
    await loadPeakSignals();
  };
  const handlePeakDelete = async (signal: PeakSignalModel) => {
    await service.deletePeakSignal(signal.id);
    await loadPeakSignals();
  };

  if (loading) {
    return <SpinnerDefault />;
  }

  return (
    <TitlelessCard className="p-3">
      <PeakSignalTable
        peakSignals={peakSignals}
        config={gaugeConfig}
        scrollWithPage={true}
        canEdit={canEditPeaks}
        onUpdate={handlePeakUpdate}
        onDelete={handlePeakDelete}
      />
    </TitlelessCard>
  );
}

export default InspectionsDataPeakSignals;
